import { render, staticRenderFns } from "./DialogConfirmDeletion.vue?vue&type=template&id=f1d12014&scoped=true"
import script from "./DialogConfirmDeletion.vue?vue&type=script&lang=js"
export * from "./DialogConfirmDeletion.vue?vue&type=script&lang=js"
import style0 from "./DialogConfirmDeletion.vue?vue&type=style&index=0&id=f1d12014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d12014",
  null
  
)

export default component.exports